<ng-container *ngIf="dataLoaded">
  <finra-card-wrapper>
    <finra-card show-expand-control="false" expanded="true" show-menu-control="false">
      <h1>MU3 Submitted</h1>
      <p>
        <span *ngIf="isCompanyUser"
          >The MU3 for {{ individualName?.firstName }} {{ individualName?.middleName }} {{ individualName?.lastName }}
          {{ individualName?.suffix }} ({{ individualEntityId }})</span
        ><span *ngIf="!isCompanyUser">Your MU3</span> has been submitted<span *ngIf="hasLicenses">
          and is processing for the following licenses/applications:</span
        >
      </p>
      <ul *ngIf="hasLicenses">
        <li *ngFor="let description of licenseDetails">{{ description }}</li>
      </ul>
      <h2>Next Steps</h2>
      <ul>
        <li>
          An email will be sent to {{ notificationEmail || 'your registered email' }} once the submission has finished
          processing along with any additional important tasks for you to complete.
        </li>
        <li *ngIf="hasNewLicenseApplication">
          This filing contains a new individual license application. You can now request sponsorship through the
          <a [href]="relationshipDetailsUrl">Company Relationship</a>.
        </li>
        <li>
          If this filing was prompted by a regulator's information request, return to your
          <a (click)="openOutstandingIRs()" class="link">Outstanding Information Requests</a> task list to notify them
          that your changes are complete. You can also check there for any other pending requests requiring action.
        </li>
      </ul>
      <div class="spacer"></div>
      <ng-container *ngIf="hasPayment">
        <h2>Confirmation Number</h2>
        <p class="confirmation-padding">
          <a (click)="openInvoiceInfoUrl()">Confirmation {{ confirmationNumber }}</a> can be found on the NMLS invoice
          search screen.
        </p>
      </ng-container>
      <finra-button (click)="finishRouting()">Finish</finra-button>
    </finra-card>
  </finra-card-wrapper>
</ng-container>

<div class="form-content">
  <ng-container *ngIf="!dataLoaded">
    <div class="center-page">
      <finra-spinner [isBackdrop]="false"></finra-spinner>
    </div>
  </ng-container>
</div>
